import { gql } from '@apollo/client';
import { graphql } from '@xolv-mybrightlink/common';
import { Course, Lesson } from '../models/Course';
import _ from 'lodash';

const GET_COURSE_LIST_QUERY = gql`
  query lmsCourses($languageCode: String) {
    lmsCourses(languageCode: $languageCode) {
      id
      title
      thumbnail
      numOfLessons
      percentage
      completed
    }
  }
`;

const GET_ASSIGNED_COURSE = gql`
  query assignedLessons {
    assignedLessons
  }
`;

const GET_LESSON_COURSE_BY_IDS = gql`
  query lmsLessons($lessonIds: [Int]) {
    lmsLessons(lessonIds: $lessonIds) {
      id
      title
      courseId
      courseTitle
    }
  }
`;

const GET_LESSON_BY_COURSE_ID = gql`
  query lmsCourseDetailLessons($courseId: Int) {
    lmsCourseDetailLessons(courseId: $courseId) {
      id
      title
      courseId
      courseTitle
      lessonMaterials
      lessonEmbeddedImage
      videoKey
    }
  }
`;

const GET_COMPLETED_LESSONS_BY_COURSE_ID = gql`
  query lmsCompletedLessons($courseId: Int) {
    lmsCompletedLessons(courseId: $courseId)
  }
`;

export const getCourseList = async (): Promise<Course[]> => {
  try {
    const response = await graphql.query<{
      lmsCourses: Course[];
    }>({
      query: GET_COURSE_LIST_QUERY,
      variables: {
        languageCode: 'en',
      },
      fetchPolicy: 'no-cache',
    });

    return response.data.lmsCourses;
  } catch (e) {
    console.debug('Failed to get course list');
    return [];
  }
};

export const getAssignedLessonIds = async (
  languageCode: string,
): Promise<number[]> => {
  try {
    const response = await graphql.query<{
      assignedLessons: number[];
    }>({
      query: GET_ASSIGNED_COURSE,
      variables: {
        languageCode: languageCode,
      },
    });
    return response.data.assignedLessons;
  } catch (e) {
    console.debug('Failed to get assigned lesson ids');
    return [];
  }
};

export const getLessons = async (lessonIds: number[]): Promise<Lesson[]> => {
  try {
    const response = await graphql.query<{
      lmsLessons: Lesson[];
    }>({
      query: GET_LESSON_COURSE_BY_IDS,
      variables: {
        lessonIds,
      },
    });
    return response.data.lmsLessons;
  } catch (e) {
    console.debug('Failed to get lessons');
    return [];
  }
};

export const getLessonsByCourseId = async (courseId: number) => {
  try {
    const response = await graphql.query<{
      lmsCourseDetailLessons: Lesson[];
    }>({
      query: GET_LESSON_BY_COURSE_ID,
      variables: {
        courseId,
      },
    });
    return _.sortBy(
      response.data.lmsCourseDetailLessons,
      (lesson) => lesson.title,
    );
  } catch (e) {
    console.debug('Failed to get lessons');
    return [];
  }
};

export const getCompletedLessonsByCourseId = async (courseId: number) => {
  try {
    const response = await graphql.query<{
      lmsCompletedLessons: number;
    }>({
      query: GET_COMPLETED_LESSONS_BY_COURSE_ID,
      variables: {
        courseId,
      },
      fetchPolicy: 'no-cache',
    });
    return response.data.lmsCompletedLessons;
  } catch (e) {
    console.debug('Failed to get lessons');
    return [];
  }
};
